angular.module('bb.listing', [
  'bb.listing_view',
  'bb.appointments',
  'bb.listing_search',
  'bb.listing_preview',
  'bb.listing_contacts',
]);

require('./appointments/appointments.module');
require('./view/listing_view.module');
require('./search/listing_search.module');
require('./preview/listing_preview.module');
require('./contacts/listing_contacts.module');
require('./alerts/alerts.module');
